"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExternalAnalyticsPayload = exports.parseEventNameForAnalytics = void 0;
var parseEventNameForAnalytics = function (str) {
    if (str === void 0) { str = ''; }
    if (!str) {
        return {
            elementTitle: '',
            flowOutcome: ''
        };
    }
    if (str === 'Shopper Platform Init') {
        return {
            elementTitle: 'Shopper Platform',
            flowOutcome: 'init'
        };
    }
    var toLowerCase = str.toLowerCase();
    var eventNameArray = toLowerCase.split('_');
    if (eventNameArray[0] === 'dr') {
        eventNameArray.splice(0, 1);
    }
    var flowOutcome = eventNameArray.pop().trim();
    var initialLetterUpperCase = function (text) { return (text[0] || '').toUpperCase() + text.substring(1).trim(); };
    var elementTitle = eventNameArray.map(function (eventName) { return initialLetterUpperCase(eventName); }).join(' ');
    return {
        elementTitle: elementTitle,
        flowOutcome: flowOutcome
    };
};
exports.parseEventNameForAnalytics = parseEventNameForAnalytics;
var getExternalAnalyticsPayload = function (vehicle) {
    var metadata = {
        pageType: 'vdp',
        eventOwner: 'CAI',
        vehicle: {
            vin: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.vin) || (vehicle === null || vehicle === void 0 ? void 0 : vehicle.uuid) || (vehicle === null || vehicle === void 0 ? void 0 : vehicle.vehicleId) || '',
            stockNumber: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.stockNumber) || '',
            condition: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.condition) || '',
            year: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.year) || '',
            make: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.make) || '',
            model: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.model) || '',
            trim: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.trim) || '',
            color: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.exteriorColor) || '',
            type: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.bodyStyle) || '',
            fuel: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.fuel) || '',
            inventoryDate: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.inventoryDate) || '',
            price: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.retailPrice) || ''
        }
    };
    return metadata;
};
exports.getExternalAnalyticsPayload = getExternalAnalyticsPayload;
